import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import axios from '../../utils/axios';
import { stringScissors } from '../../utils/string';
import Anchor from './buttons/Anchor';
import IconButton from './buttons/IconButton';


const HEIGHT_OF_TABLE_HEAD = 58;
const HEIGHT_OF_TABLE_ROW = "5";
const MAX_HEIGHT_OF_TABLE = "58.5vh";
const PAGINATION_ROW_OPTIONS = [10, 25, 50, 100];


const ListTable = ({columns, list_url, items, callback=false}) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGINATION_ROW_OPTIONS[0]);
  const [rows, setRows] = useState([]);

  // the result of callback should be iterable
  const createRowsData = (data, callback) => {
    if (typeof callback === 'function') {

      const result = data.map(item => {
        return callback(item);
      })

      return setRows(result);
    }
    return setRows(data);
  }

  useEffect(() => {
    const getUserList = async () => {

      try {
        let data = [];
        if (items == null) {
          const response = await axios.get(list_url);
          data = response.data;
        } else {
          data = items;
        }

        createRowsData(data, callback);
      } catch (error) {
        console.error(error);
      }
    };
    getUserList();
  }, [items]);


  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  return (
    <>
      <TableContainer 
        sx={{
          width: "100%",
          overflow: "auto",
          position: "relative",
          maxHeight: MAX_HEIGHT_OF_TABLE,
          height: HEIGHT_OF_TABLE_HEAD + HEIGHT_OF_TABLE_ROW * rowsPerPage + "vh"
        }}
      >
        <Table stickyHeader aria-label="sticky table" sx={{width: "100%", minWidth: "max-content", position: "absolute"}}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  title={column.label}
                  sx={{
                    fontWeight: "bold",
                    color: "rgb(16, 87, 200)",
                    opacity: '1',
                    textAlign: column.textAlign ? 'center' : 'left'
                  }}
                >
                  {stringScissors(column.label)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" sx={{height: HEIGHT_OF_TABLE_ROW + 'vh'}} tabIndex={-1} key={row.id} rowid={row.id}>
                    {columns.map((column) => {
                    const value = row[column.id];
                    const cutValue = stringScissors(value)
                    return (
                      <TableCell 
                        align={column.align} 
                        key={[column.id, row.id].join('-')}
                      >
                        {column.format ? column.format(cutValue) : cutValue}
                      </TableCell>
                    );
                    })}
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={PAGINATION_ROW_OPTIONS}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default ListTable;


const TableLinkBtn = ({children, to}) => {
  
  return (<div style={{textAlign: 'right', marginBottom: '1em'}}><Anchor to={to} sx={{display: 'inline'}}><IconButton>{children}</IconButton></Anchor></div>)
}
export {TableLinkBtn}

